import { BundleDefaults } from './typings';

const defaults: BundleDefaults = {
  appTheme: '3a49337c5724d18079602a4ca5a91626', // This is a reference to the appTheme MD5 Hash in UX Server
  urls: {
    apiBaseUrl: 'http://localhost:8001',
    uxBaseUrl: 'http://localhost:3000',
    widgetBaseUrl: 'http://localhost:1986/dist',
    logException: `http://localhost:8001/api/v1/partners/widgets/log_exception/`
  },
  pendingClickIndex: -1,
  version: {
    major: 0,
    git: null
  },
  googleTagId: undefined,
  vehicles: [],
  mobileBreakpoint: 992,
  inventoryMsrpColor: '#4C4C4C',
  inventorySubtitleColor: '#666666',
  // The below values can get overwritten by domain files via PartnerWidgetConfiguration
  doc_fee: 0,
  apr_percent: 9.74,
  term_months: 84,
  cta_text: 'Get Prequalified',
  estimate_payment_cta_text: 'Estimate Payment',
  cta_button_color: '#3BB9FF',
  homepage_cta_button_color: '#3BB9FF',
  srp_cta_button_color: '#3BB9FF',
  sidebar_cta_button_color: '#3BB9FF',
  cta_button_text_color: '#000000',
  minicta_button_msrp_text_color: '#000000',
  enable_cta_widget: true,
  show_monthly_payment: true,
  enable_vwo_testing: false,
  enable_data_layer_events: true,
  flow_type: 'two_step',
  enable_estimate_payment_step: false,
  enable_vehicle_selection_step: false,
  show_estimate_payment_step: false,
  enable_homepage_cta_widget: false,
  enable_srp_cta_widget: false,
  enable_sidebar_cta_widget: false,
  enable_finance_page_widget: false,
  partner: {
    partner_identifier: 'dum_e_test_partner',
    name: 'Test Partner'
  },
  filter_groups: [],
  // used by internal demo site
  demoCtaStyle: 'standard',
  partner_google_tag_id: null
};

export default defaults;
